<template>
	<div class="horizontal-scroller-fitter">
		<div @scroll="onScroll" class="horizontal-scroller" ref="scroller">
			<slot></slot>
		</div>
		<v-btn @click="clickLeft()" class="horizontal-btn btn-left" fab small color="primary">
			<v-icon>mdi-chevron-left</v-icon>
		</v-btn>
		<v-btn @click="clickRight()" class="horizontal-btn btn-right" fab small color="primary">
			<v-icon>mdi-chevron-right</v-icon>
		</v-btn>
	</div>
</template>
<script>
export default {
    data: () => ({
        interval: null
    }),
    methods: {
        onScroll() {
            var a = this.$refs["scroller"].scrollLeft;
            var b = this.$refs["scroller"].scrollWidth - this.$refs["scroller"].clientWidth;
            var c = a / b;
            var btnLeft = this.$refs["scroller"].parentElement.getElementsByClassName("btn-left")[0];
            var btnRight = this.$refs["scroller"].parentElement.getElementsByClassName("btn-right")[0];
            if(isNaN(c) || c <= 0.05) {
                btnLeft.style.display = "none";
            }else {
                btnLeft.style.display = "block";
            }
            if(isNaN(c) || c >= 0.95) {
                btnRight.style.display = "none";
            }else{
                btnRight.style.display = "block";
            }
        },
        clickRight() {
            if(typeof this.$refs["scroller"].scrollBy === 'function') {
                this.$refs["scroller"].scrollBy({
                    top: 0,
                    left: 120,
                    behavior: 'smooth'
                });
            }else{
                this.$refs["scroller"].scrollLeft = this.$refs["scroller"].scrollLeft + 120;
            }
        },
        clickLeft() {
            if(typeof this.$refs["scroller"].scrollBy === 'function') {
                this.$refs["scroller"].scrollBy({
                    top: 0,
                    left: -120,
                    behavior: 'smooth'
                });
            }else{
                this.$refs["scroller"].scrollLeft = this.$refs["scroller"].scrollLeft - 120;
            }
        }
    },
    mounted() {
        this.onScroll();
        this.interval = setInterval(() => {
            this.onScroll();
        }, 1000);
    },
    destroyed() {
        if(this.interval != null) {
            clearTimeout(this.interval);
            this.interval = null;
        }
    }
};
</script>
<style scoped>
.horizontal-scroller-fitter {
    position: relative;
    width: 100%;
}
.horizontal-scroller {
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    -ms-overflow-style: none;
}
.horizontal-scroller::-webkit-scrollbar {
    display: none;
}
.horizontal-item {
    width: 128px;
}
.horizontal-btn {
    position: absolute;
    top: 50%;
    margin-top: -20px;
}
.horizontal-btn.btn-right {
    right: 10px;
}
.horizontal-btn.btn-left {
    left: 10px;
}
</style>
<style scoped>
.horizontal-scroller .horizontal-item {
    width: 96px;
}
.horizontal-item-title {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.9em;
    margin-top: 5px;
}
</style>